import React, { useState, useEffect } from "react";
// import { BASE_URL } from "../_globalConstants.js";


export default function AdminCreate() {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => setSuccessMessage(false), 3000);
        }
        if (errorMessage) {
            setTimeout(() => setErrorMessage(false), 3000);
        }
    }, [successMessage, errorMessage]);

    async function createOrganization(e) {
        // This function makes a POST request to the backend
        // to create a new organization. 

        e.preventDefault();

        // Body of the request
        const org_stub = {
            company_name: document.getElementById("name").value,
            company_primary_poc: document.getElementById("poc_name").value,
            company_primary_poc_email: document.getElementById("poc_email").value,
        }

        try {
            const response = await fetch("/api/admin/company", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(org_stub),
            });

            if (response.ok) {
                // alert("Organization created successfully!");
                // Clear the form
                document.getElementById("name").value = "";
                document.getElementById("poc_name").value = "";
                document.getElementById("poc_email").value = "";
            } else {
                // alert("Failed to create organization.");
                const error = await response.text();
                setErrorMessage(error || "Failed to create organization.");
            }
        } catch (error) {
            console.error("Failed to create organization.", error);
            setErrorMessage("Failed to create organization.");
        }
    }

    function Popup({ message, onClose, error }) {
        return (
            <div className={error ? "popup error-popup" : "popup success-popup"}>
                <div className="popup-content">
                    <p>{message}</p>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-create-container">
            <form onSubmit={createOrganization}>
                <div className="form-group">
                    <label htmlFor="name">Organization Name</label>
                    <input type="text" className="form-control" id="name" />
                </div>
                <div className="form-group">
                    <label htmlFor="name">Organization Primary Point of Contact</label>
                    <input type="text" className="form-control" id="poc_name" />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Organization Primary Point of Contact Email</label>
                    <input type="email" className="form-control" id="poc_email" />
                </div>
                <button type="submit" className="btn btn-primary">
                    Submit
                </button>
            </form>
            {successMessage && <Popup message={successMessage} onClose={() => setSuccessMessage(false)} error={false} />}
            {errorMessage && <Popup message={errorMessage} onClose={() => setErrorMessage(false)} error={true} />}
        </div>
    );
    }